import { Link, useNavigate } from 'react-router-dom';
import { GovCard, GovIcon, GovLayout } from '@gov-design-system-ce/react';
import { MarkdownRender } from '@gov-nx/component/web';
import { useLocale } from '@gov-nx/core/service';
import { PageCode, useRozcestnikContext } from '@gov-nx/module/page';
import { Button, LayoutGap, SectionHeader } from '@gov-nx/ui/web';
import { truncate } from '@gov-nx/utils/common';

export const HomepageFOServicesSection = () => {
	const { t } = useLocale(PageCode['rozcestnik']);
	const { data } = useRozcestnikContext();
	const navigate = useNavigate();
	const signpost = data[0];

	if (!signpost.action) return null;

	return (
		<section aria-labelledby="zacnete-s-podnikanim">
			<LayoutGap gap="l">
				<SectionHeader
					id="zacnete-s-podnikanim"
					headline={t('nadpis.zacnete-s-podnikanim')}
				/>
				<GovLayout
					type="text"
					variant="left">
					<article className="h-full">
						<GovCard
							direction="horizontal"
							key={signpost.id}
							onClick={() =>
								signpost.action.isLink
									? navigate(signpost.action.to)
									: signpost.action.onClick()
							}
							img={
								<img
									src="/assets/images/docasne/thumb-laptop.png"
									width="240"
									height="222"
									alt=""
									slot="img"
								/>
							}>
							<LayoutGap gap="s">
								<h3 className="text-headline-s! text-(--text-primary-color)">
									{signpost.icon ? (
										<GovIcon
											name={signpost.icon.icon as string}
											type={signpost.icon.file as string}
										/>
									) : null}
									{signpost.name}
								</h3>
								{signpost.description && (
									<MarkdownRender className="mt-0!">
										{truncate(signpost.description, 150)}
									</MarkdownRender>
								)}
								{signpost.externalService?.links?.length &&
									signpost.externalService.links.map((link) => (
										<Button
											asChild
											key={link.link}
											color="secondary"
											size="m"
											iconEnd={<GovIcon name="box-arrow-up-right" />}
											type="solid">
											<Link
												to={link.link as string}
												target="_blank">
												{t('akce.prejit-na-portal-notarske-komory')}
											</Link>
										</Button>
									))}
							</LayoutGap>
						</GovCard>
					</article>
				</GovLayout>
			</LayoutGap>
		</section>
	);
};
